import { HttpParams } from "@angular/common/http";
import { AppConstants } from "../../common/constants/app-constants";
import { CarBusinessLine } from "../../car/constants/car-basic-data";

export class DealerCriteria {
  pageNumber: number = 0;
  pageSize: number = AppConstants.PAGE_SIZE_DEFAULT;
  
  dealerIds : string[] = [];
  dealerTypes : string[] = [];
  civilities : string[] = [];
  fnames : string[] = [];
  lnames : string[] = [];
  businessNames : string[] = [];
  businessTypes : string[] = [];

  addresses : string[] = [];
  emails : string[] = [];

  servicesProvided : string[] = [];
  specialtyMakes : string[] = [];
  favoriteProviderIds : string[] = [];

  countries : string[] = [];
  cities : string[] = [];

  statuses : string[] = [];

  minCreatedDate  = "";
  maxCreatedDate = "" ;

  businessLine? : CarBusinessLine = CarBusinessLine.BUY;

  public getHttpParams(): HttpParams {
    
    return new HttpParams()
                .append('pageNumber', this.pageNumber)
                .append('pageSize', this.pageSize)

                .append('dealerIds', this.dealerIds.join(', '))
                .append('civilities', this.civilities.join(', '))
                .append('fnames', this.fnames.join(', '))
                .append('lnames', this.lnames.join(', '))
                
                .append('businessNames', this.businessNames.join(', '))
                .append('businessTypes', this.businessTypes.join(', '))
                .append('addresses', this.addresses.join(', '))
                .append('emails', this.emails.join(', '))

                .append('servicesProvided', this.servicesProvided.join(', '))
                .append('specialtyMakes', this.specialtyMakes.join(', '))
                .append('favoriteProviderIds', this.favoriteProviderIds.join(', '))

                .append('countries', this.countries.join(', '))
                .append('cities', this.cities.join(', '))

                .append('statuses', this.statuses.join(', '))

                .append('minCreatedDate', this.minCreatedDate)
                .append('maxCreatedDate', this.maxCreatedDate);
    
  }
}